import type { ProviderIdentifier } from "@/services/ProviderCookie/types";
import { isProductionEnv } from "@/utils/environment";

export const VALID_PSP_VALUES: ProviderIdentifier[] = [
  "macropay",
  "stripe",
  "fake",
  "stripe_billing",
];

/** Stripe-family PSPs that accept an explicit merchant/account (`mid`) override. */
export const STRIPE_PROVIDER_IDENTIFIERS: ProviderIdentifier[] = ["stripe", "stripe_billing"];

export const isStripeProviderIdentifier = (
  value: ProviderIdentifier | null | undefined
): value is "stripe" | "stripe_billing" =>
  value !== null && value !== undefined && STRIPE_PROVIDER_IDENTIFIERS.includes(value);

/**
 * The `mid` (merchant account) override to forward to the provider pick, or
 * `undefined` when it is not allowed. Central gate: only Stripe-family PSPs in
 * non-prod environments may force an account via `mid`. The backend validates
 * this independently; this gate guarantees zero prod impact from the frontend.
 */
export const resolveMidOverride = (
  psp: ProviderIdentifier | null | undefined,
  mid: string | null | undefined
): string | undefined => {
  const trimmedMid = mid?.trim();
  if (!trimmedMid) return undefined;

  return isStripeProviderIdentifier(psp) && !isProductionEnv() ? trimmedMid : undefined;
};
